import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Zap, Heart, Users, Award } from "lucide-react";
import { useLanguage } from "../../../i18n/LanguageContext";

export default function AboutMission() {
  const { t } = useLanguage();
  const about = t.about;

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const iconMap = {
    zap: <Zap />,
    heart: <Heart />,
    users: <Users />,
    award: <Award />,
  };

  return (
    <div className="about-page">
      {/* استخدمت كلاس values section-padding عشان المسافات تكون نفس باقي الموقع وما تطلع الصفحة فاضية */}
      <section className="hero" data-aos="fade-down">
        <svg
          className="hero-pattern"
          viewBox="0 0 680 400"
          preserveAspectRatio="none"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.13">
            {[
              [10, 10, 28, 9, -55, "#411428"],
              [60, 40, 38, 9, 15, "#FF4B32"],
              [110, 8, 18, 9, -80, "#411428"],
              [155, 55, 34, 9, 30, "#733635"],
              [210, 15, 26, 9, -40, "#FF4B32"],
              [270, 70, 40, 9, 10, "#411428"],
              [330, 5, 22, 9, -70, "#733635"],
              [395, 45, 36, 9, 45, "#FF4B32"],
              [455, 20, 28, 9, -20, "#411428"],
              [515, 80, 32, 9, 60, "#733635"],
              [575, 12, 24, 9, -50, "#FF4B32"],
              [630, 50, 38, 9, 25, "#411428"],
              [30, 90, 30, 9, -65, "#FF4B32"],
              [180, 95, 26, 9, 40, "#733635"],
              [380, 100, 20, 9, -30, "#FF4B32"],
              [500, 105, 34, 9, 15, "#411428"],
              [20, 200, 32, 9, -45, "#733635"],
              [90, 230, 28, 9, 20, "#FF4B32"],
              [200, 190, 36, 9, -60, "#411428"],
              [320, 250, 24, 9, 35, "#733635"],
              [440, 210, 30, 9, -25, "#FF4B32"],
              [560, 240, 38, 9, 50, "#411428"],
              [15, 320, 26, 9, -40, "#FF4B32"],
              [140, 350, 34, 9, 25, "#733635"],
              [280, 310, 22, 9, -70, "#411428"],
              [420, 360, 30, 9, 15, "#FF4B32"],
              [590, 330, 28, 9, -55, "#733635"],
            ].map(([x, y, w, h, r, fill], i) => (
              <rect
                key={i}
                x={x}
                y={y}
                width={w}
                height={h}
                rx="2"
                fill={fill}
                transform={`rotate(${r} ${x} ${y})`}
              />
            ))}
          </g>
        </svg>

        <div className="hero-content">
          <h1>{about.heroTitle}</h1>
          <p>{about.heroText}</p>
        </div>
      </section>

      <main className="container about-page__container">
        {/* قسم المهمة - تنظيم المحتوى نص وصورة لضمان توازن الصفحة */}
        <section className="about-mission" data-aos="fade-up">
          <div className="about-mission__text" data-aos="fade-up" data-aos-delay="100">
            <h2 className="about-section-title">{about.missionTitle}</h2>
            {about.missionLines.map((line, idx) => (
              <p key={idx} className="about-mission__line">
                {line}
              </p>
            ))}
          </div>

          <div className="about-mission__media" data-aos="fade-up" data-aos-delay="200">
            <img
              src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800"
              alt={about.heroTitle}
              className="about-mission__image"
            />
          </div>
        </section>

        {/* استخدمت الجريد حق الموقع عشان تترتب الكروت جنب بعض بشكل تلقائي ومنظم */}
        <section className="values about-values">
          <h2
            className="about-section-title about-section-title--center"
            data-aos="fade-up"
          >
            {about.valuesTitle}
          </h2>
          
          <div className="about-values__grid">
            {/* لظهور الصفحة بشكل احترافي اضفت له انيميشن لكرت الرؤية: fade-up */}
            {about.values.map((item, index) => (
              <div 
                key={index}
                data-aos="fade-up"
                data-aos-delay={150 + index * 120}
                className="about-value-card"
              >
                <div className="about-value-card__icon" aria-hidden="true">
                  {iconMap[item.icon] ?? <Zap />}
                </div>
                <h3 className="about-value-card__title">{item.title}</h3>
                <p className="about-value-card__desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

